import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import URI from 'urijs';
import { SearchFacets } from 'Components/widgets/criteria/criteria-facets/search-facets/SearchFacets';
import { CriteriaContext } from 'Components/widgets/criteria/CriteriaContext';
import {
  activeCustomFacetsSelector,
  activeFacetsSelector,
  facetsSelector,
} from 'Store/faceting/faceting.selector';
import { clearFacets, clearAll, toggleFacet } from 'Store/faceting/facetingSearch.action';
import { getDepartureCity } from 'Store/trip-criteria/tripCriteria.selector';
import { SORT_BY_PRICE_QUERY_PARAM } from 'Utils/faceting/constants';
import { getFacetTemplateConfig } from './CriteriaFacets.utils';
export const CriteriaFacets = () => {
  const dispatch = useDispatch();
  const activeCustomFacets = useSelector(activeCustomFacetsSelector);
  const activeFacets = useSelector(activeFacetsSelector);
  const departureCity = useSelector(getDepartureCity);
  const facets: Array<SearchFacetCategory> = useSelector(facetsSelector);
  const orderByPriceState = useSelector(({ faceting }) => faceting.orderByPrice);
  const router = useRouter();
  const [criteriaContext] = useContext(CriteriaContext);
  const uri = new URI(router.asPath);
  return (
    <SearchFacets
      activeCustomFacets={activeCustomFacets}
      activeFacets={activeFacets}
      clearFacetList={(categoryId) => {
        dispatch(clearFacets(categoryId));
      }}
      clearAll={() => {
        dispatch(clearAll());
      }}
      facets={facets}
      facetTemplateConfig={getFacetTemplateConfig(criteriaContext, departureCity)}
      orderByPrice={orderByPriceState}
      setOrderByPrice={(orderByPrice) => {
        const searchPageUrl = uri.clone().setQuery({
          [SORT_BY_PRICE_QUERY_PARAM]: orderByPrice || undefined,
        });
        router.replace(searchPageUrl.toString(), undefined, {
          shallow: true,
          scroll: false,
        });
      }}
      toggleFacet={({ categoryId, isSelected, value }) => {
        criteriaContext.setFacetHasSeeMore(false);
        dispatch(
          toggleFacet({
            categoryId,
            isSelected,
            value,
          }),
        );
      }}
    />
  );
};
